// @ts-nocheck
import { injectCss } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import styled from "styled-components";

export const widgetWrapperStyles: InjectableCss = {
    css: spacingStyles(),
};

const WidgetWrapper = styled.div<InjectableCss>`
    ${widgetWrapperStyles.css}
    ${injectCss}
`;

export default WidgetWrapper;
